<app-confirm-action-modal
  testId="delete-package-dialog"
  title="Delete Package?"
  message="Are you sure you want to delete this package? This action cannot be undone."
  confirmLabel="Delete"
  [mobileSheet]="false"
  (confirm)="onConfirm()"
  (cancel)="onClose()"
></app-confirm-action-modal>
